export default __webpack_public_path__ + "static/media/img-49-phoenix.635c61c1.jpg";